import Icon from '@ant-design/icons';
import { passwordShowSvg, passwordHideSvg, errorIconSvg } from './svg-data';

export const PasswordShowIcon = (props: any) => <Icon component={passwordShowSvg} {...props} />;

export const PasswordHideIcon = (props: any) => <Icon component={passwordHideSvg} {...props} />;

export const CircleErrorIcon = (props: any) => <Icon component={errorIconSvg} {...props} />;
